import { render, staticRenderFns } from "./MakesCarousel.vue?vue&type=template&id=82ccd5d6&scoped=true&"
import script from "./MakesCarousel.vue?vue&type=script&lang=ts&"
export * from "./MakesCarousel.vue?vue&type=script&lang=ts&"
import style0 from "./MakesCarousel.vue?vue&type=style&index=0&id=82ccd5d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82ccd5d6",
  null
  
)

export default component.exports